import { getQueryParam } from '../routing/getQueryParam';
import { normalizeUrl } from '../utils/normalizeUrl';
const FORWARDED_PARAMS = ['client_id', 'redirect_uri', 'scope', 'state', 'code_challenge', 'code_challenge_method'];
export const getOauthRedirect = () => {
  const loginRedirectUrl = new URL(normalizeUrl(getQueryParam('loginRedirectUrl')));
  const {
    hostname,
    pathname,
    searchParams
  } = loginRedirectUrl;
  const redirectUrlSearchParams = new URLSearchParams();
  FORWARDED_PARAMS.forEach(param => {
    const value = searchParams.get(param);
    if (value !== null) {
      redirectUrlSearchParams.set(param, value);
    }
  });
  const redirectUrl = new URL(`https://${hostname}${pathname}?${redirectUrlSearchParams.toString()}`);
  return redirectUrl.href;
};